import { useEffect, useRef, type EffectCallback } from 'react';
import { useRouter } from 'next/router';

/**
 * Run a effect function on pageload, either with hard reload or NextJS's internal routing, only once.
 * @param effect Any effect callback function
 */
export function usePageLoadEffect(effect: EffectCallback, deps?: any) {
  const router = useRouter();
  const hasRun = useRef(false);

  useEffect(() => {
    if (deps && !hasRun.current) {
      const delay = setTimeout(() => {
        effect();
        hasRun.current = true;
      }, 0);

      // To avoid fire event twice. react^18, on development mode.
      return () => {
        clearTimeout(delay);
      };
    }
  }, [router.asPath, effect, deps]);
}
